'use strict';

var chunkFYGG567E_js = require('./chunk-FYGG567E.js');
var chunkWNNKWDCR_js = require('./chunk-WNNKWDCR.js');
var chunkATB4Z7GO_js = require('./chunk-ATB4Z7GO.js');
var chunk7GTRMEIW_js = require('./chunk-7GTRMEIW.js');
var chunkGWPDT7BR_js = require('./chunk-GWPDT7BR.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var o = require('react');
var e = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var o__default = /*#__PURE__*/_interopDefault(o);
var e__default = /*#__PURE__*/_interopDefault(e);

var w=e__default.default.div`
  background-color: ${({$navOptionStyleConfig:t})=>t.backgroundColor};
  padding-top: ${({$navOptionStyleConfig:t})=>t.paddingTop};
  padding-left: ${({$navOptionStyleConfig:t})=>t.paddingLeft};
  padding-bottom: ${({$navOptionStyleConfig:t})=>t.paddingBottom};
  border-radius: ${({$navOptionStyleConfig:t})=>t.borderRadius};
  flex-grow: ${({$navOptionStyleConfig:t})=>t.sidebarFlexGrow};
  min-width: ${({$navOptionStyleConfig:t})=>t.containerMinWidth};
  max-width: ${({$navOptionStyleConfig:t})=>t.containerMaxWidth};
`,C=e__default.default.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`,I=e__default.default.div`
  height: ${({$navOptionStyleConfig:t})=>t.headerHeight};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${({$navOptionStyleConfig:t})=>t.headerMargin};
`,h=e__default.default.div`
  background-color: ${({$activeIndex:t,$currentIndex:i,$navOptionStyleConfig:n})=>t===i?n.activeOptionColor:n.backgroundColor};
  border-top-left-radius: ${({$activeIndex:t,$currentIndex:i,$navOptionStyleConfig:n})=>t===i&&n.activeOptionBorderRadius};
  border-bottom-left-radius: ${({$activeIndex:t,$currentIndex:i,$navOptionStyleConfig:n})=>t===i&&n.activeOptionBorderRadius};
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${({$navOptionStyleConfig:t})=>t.optionPadding};
  &:not(:last-child) {
    margin-bottom: ${({$navOptionStyleConfig:t})=>t.optionMarginBottom};
  }
`,T=e__default.default.div`
  padding: ${({$navOptionStyleConfig:t})=>t.optionPadding};
`,B=e__default.default.a`
  display: flex;
  justify-content: space-between;
  margin-top: ${({$navOptionStyleConfig:t})=>t.linkMarginTop};
  text-decoration: none;
`,H=({title:t,suffixButton:i,onHover:n,links:s=[],options:v,activeIndex:b})=>{let{tokens:a}=chunkHUKGHOBJ_js.b(),{navbarOptionsStyling:r}=chunkWNNKWDCR_js.a(a),{title:S,onClick:y,asLink:x=!1,href:O=""}=i||{};return o__default.default.createElement(w,{$navOptionStyleConfig:r},o__default.default.createElement(C,null,t&&o__default.default.createElement(I,{$navOptionStyleConfig:r},o__default.default.createElement(chunkATB4Z7GO_js.a,{isBold:!0,color:a.text_default_text_primary},t),o__default.default.createElement(chunkGWPDT7BR_js.a,{label:S,onClick:()=>y&&y(),variant:"brand",size:"small",underLine:!1,asLink:x,href:O,preventDefaultBehaviour:!0})),v.map((p,d)=>o__default.default.createElement(h,{key:p.title,onMouseEnter:()=>n(d),$navOptionStyleConfig:r,$activeIndex:b,$currentIndex:d},o__default.default.createElement(chunkATB4Z7GO_js.a,{color:a.text_default_text_primary},p.title),o__default.default.createElement(chunk7GTRMEIW_js.a,{rotateBy:270,size:"16"})))),s&&s.map(p=>{let{title:d="",url:$="",suffixIcon:k=o__default.default.createElement(chunkFYGG567E_js.a,{rotateBy:315,size:"16px"})}=p||{};return o__default.default.createElement(T,{key:d,$navOptionStyleConfig:r},o__default.default.createElement(B,{$navOptionStyleConfig:r,href:$,target:"_blank"},o__default.default.createElement(chunkATB4Z7GO_js.a,{color:a.text_default_text_primary},d),k))}))};

exports.a = H;
